import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import AulaDetailsArea from '../components/common/aula/aula-details';
import Cta from '../components/common/cta/cta';
import SEO from '../components/seo';
import Footer from '../layout/footers/footer';
import Header from '../layout/headers/header';
import Wrapper from '../layout/wrapper';
import { showModulo } from '../api/modulo';
import { retrieveToken } from './../hooks/use-token';

const DynamicAulaDetails = () => {

  const { id } = useParams();
  const [modulo, setModulo] = useState(null);

  useEffect(() => {

    const tokenApi = retrieveToken();

    if (modulo == null) {
      showModulo(tokenApi, Number(id)).then(function(result) {
        setModulo(result);
      });
    }

});

  return (
    <Wrapper>
      {/* seo start */}
      <SEO pageTitle={'Aulas do Módulo'} />
      {/* seo end */}

      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* aula details */}
      <AulaDetailsArea modulo={modulo} />
      {/* aula details */}

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
};

export default DynamicAulaDetails;